import styled from "styled-components";

import UpButton from "../up-button";

const UpResetButton = styled(UpButton)`
  background: none;
  margin: 0px;
  padding: 0px;
  > span {
    color: #696969 !important;
    text-decoration: underline;
    font-size: 12.5px;
  }
  &:hover:enabled {
    background: none;
  }
  &:disabled {
    display: none;
  }
  &:hover {
    > span {
      color: ${(props) => props.theme.primaryColor} !important;
    }
  }
  &:focus {
    outline: none;
  }
`;

export default UpResetButton;
